<template>
  <div class="form-group row">
    <label
      v-if="label != null"
      :for="id"
      class="control-label col-sm-2"
    >{{ label }}</label>

    <div
      :class="{ 'has-error': hasErrorMessage(), 'col-sm-10': label != null }"
    >
      <slot />
      <span
        v-if="hasErrorMessage()"
        class="help-block"
      >
        <strong>{{ errormessage }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputWrapper',
  props: {
    id: {
      required: true,
    },
    label: {
      required: false,
      type: String,
      default: null,
    },
    errormessage: {
      default: null,
    },
  },

  methods: {
    hasErrorMessage () {
      return this.errormessage !== null
    },

  },
}
</script>

<style scoped lang="scss">
.form-group{
  margin-top:10px;
  margin-bottom:10px;
}
</style>
